import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';

import {DEFAULT_SCROLL_SPEED, LINK_TYPE, LinkInfo2} from '../../shared/defines/client.const';
import {POOMSA, POOMSA_DISP_LISP} from '../../shared/defines/gukeo.const';
import {hunBody, hunChar} from 'src/app/shared/defines/gukeo.func';
import {Homonym} from '../../shared/models/homonym.model';
import {HomonymService} from '../../shared/services/homonym/homonym.service';
import {Word} from '../../shared/models/word.model';
import {WordBookmarkService} from '../../shared/services/word/word-bookmark.service';
import {VoiceService} from '../../shared/services/voice/voice.service';
import {OptionService} from '../../shared/services/option/option.service';
import {ScrollDownService} from "../../shared/services/scroll-down/scroll-down.service";

@Component({
  selector: 'app-homonym-detail',
  templateUrl: './homonym-detail.component.html',
  styleUrls: ['./homonym-detail.component.scss']
})
export class HomonymDetailComponent implements OnInit, OnDestroy {
  @Input() homonym: string;
  @Output() closeDetail: EventEmitter<void>;
  @Output() openLink: EventEmitter<LinkInfo2>;
  @Output() openHelp: EventEmitter<any>;

  Array = Array;
  hunBody = hunBody;
  hunChar = hunChar;

  public homonymDetail: Homonym = null;
  unlisten: () => void;
  private sendingBookmark = false;

  private playHomonym$: Subscription = null;

  // 푸터의 아래로 내리기 버튼 구독
  private scrollDown$: Subscription | null = null;

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private voice: VoiceService,
    private option: OptionService,
    private bmSvc: WordBookmarkService,
    private homonymSvc: HomonymService,
    private scrollDownSvc: ScrollDownService,
  ) {
    this.closeDetail = new EventEmitter<void>();
    this.openLink = new EventEmitter<LinkInfo2>();
    this.openHelp = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.homonymSvc.GetDetail(this.homonym).subscribe(
      data => {
        console.log(data);
        this.homonymDetail = data;

        if (this.option.autoPlay) {
          this.playHomonym$ = this.voice.PlayHomonym(this.homonymDetail).pipe(
            finalize(() => this.playHomonym$ = null )
          ).subscribe();
        }
      },
      err => console.error(err)
    );

    this.unlisten = this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
      const tar = event.target;
      // const url = decodeURI(tar.pathname);
      // alert(`text[${tar.text}] href=[${tar.getAttribute('href')}] link[${url}]`);
      if (tar instanceof HTMLAnchorElement && tar.className === 'wordlink') {
        event.preventDefault();
        console.log('anchor click = ', event);
        const idWordLink = tar.getAttribute('href');
        // alert(`text[${tar.text}] href=[${tar.getAttribute('href')}] id[${idWordLink}]`);
        this.openLink.emit({
          type: LINK_TYPE.WORD,
          id: idWordLink,
        });
      }
    });

    this.scrollDown$ = this.scrollDownSvc.pushScrollDown$().subscribe(isFirst => {
      const scrollDelta = DEFAULT_SCROLL_SPEED * (isFirst ? 2 : 1);  // 스크롤 시작할 때 첫번째는 두배로 스크롤 함.

      this.elementRef?.nativeElement.scrollTo({
        top: this.elementRef.nativeElement.scrollTop + scrollDelta,
        behavior: 'auto',
      });
    });
  }

  ngOnDestroy(): void {
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }

    if (this.playHomonym$) {
      this.playHomonym$.unsubscribe();
      this.playHomonym$ = null;
    }

    this.scrollDownSvc.popScrollDown$();
    if(this.scrollDown$)  {
      this.scrollDown$.unsubscribe();
      this.scrollDown$ = null;
    }
  }

  onClose(): void {
    this.closeDetail.emit();
  }

  onOpenHelp(): void {
    this.openHelp.emit();
  }

  public ToggleBookmark(event: MouseEvent, word: Word): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.sendingBookmark) {
      return;
    }
    this.sendingBookmark = true;

    word.bookmark = !word.bookmark;
    this.bmSvc.sendBookmark(word.id, word.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe(
      data => console.log(data),
      err => console.error(err)
    );
  }

  public getBmCss(word: Word): string {
    if (this.sendingBookmark) {
      return 'ing';
    }
    return word.bookmark ? 'on' : '';
  }

  public GetPoomsaTxt(poomsa: POOMSA): string {
    return POOMSA_DISP_LISP[poomsa];
  }

}
